module.exports = __webpack_public_path__ + "static/media/nima_moving_head.5ae5deda.gif";